import React, { useEffect, useState } from "react";
import {
  changeContactEmail,
  changeContactMobile,
  changeFinanceApprover,
  changeLineManagerApprover,
} from "../../../../utils/queries";
import { Form, FormGroup, Input, Label, Modal, ModalBody, ModalHeader } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faTimes } from "@fortawesome/free-solid-svg-icons";
import PhoneInput from "react-phone-input-2";
import { EmailSelect } from "../../../molecules/EmailSelect";
import { isNullOrEmpty, RequestHistoryType } from "../../../../utils/common";
import "../../../molecules/BrandModal.css";

const descriptions = {
  [RequestHistoryType.lineManager]: "Select a new line manager to assign to this request.",
  [RequestHistoryType.financeManager]: "Select a new finance approver to assign to this request.",
  [RequestHistoryType.contactEmail]: "Update the contact email address for this request.",
  [RequestHistoryType.contactMobile]: "Update the contact mobile number for this request.",
};

export const ChangeApproverModal = ({
  account,
  toggleModal,
  setToggleModal,
  type,
  onUpdateAccount,
  dataLoader,
  defaultValue,
}) => {
  const [approverEmail, setApproverEmail] = useState(undefined);
  const [contactMobile, setContactMobile] = useState(undefined);
  const [contactEmail, setContactEmail] = useState(undefined);
  const [showError, setShowError] = useState(false);

  const close = () => {
    setToggleModal(false);
    setApproverEmail(undefined);
    setContactEmail(undefined);
    setContactMobile(undefined);
    setShowError(false);
  };

  const getNumber = (number = "") =>
    !number.includes("+") ? `+${number}` : number;

  const validate = () => {
    if (
      !approverEmail &&
      (type === RequestHistoryType.lineManager ||
        type === RequestHistoryType.financeManager)
    ) {
      setShowError(true);
      return false;
    }
    if (isNullOrEmpty(contactEmail) && type === RequestHistoryType.contactEmail) {
      setShowError(true);
      return false;
    }
    if (isNullOrEmpty(contactMobile) && type === RequestHistoryType.contactMobile) {
      setShowError(true);
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    let response;
    if (type === RequestHistoryType.financeManager) {
      response = await changeFinanceApprover(account.id, approverEmail);
    } else if (type === RequestHistoryType.lineManager) {
      response = await changeLineManagerApprover(account.id, approverEmail);
    } else if (type === RequestHistoryType.contactEmail) {
      response = await changeContactEmail(account.id, contactEmail);
    } else if (type === RequestHistoryType.contactMobile) {
      response = await changeContactMobile(account.id, getNumber(contactMobile));
    }

    close();
    onUpdateAccount(response);
  };

  useEffect(() => {
    if (!isNullOrEmpty(defaultValue) && type === RequestHistoryType.contactMobile) {
      setContactMobile(defaultValue);
    }
    if (!isNullOrEmpty(defaultValue) && type === RequestHistoryType.contactEmail) {
      setContactEmail(defaultValue);
    }
  }, [defaultValue]);

  return account ? (
    <Modal isOpen={toggleModal} toggle={close} className="brand-modal">
      <ModalHeader toggle={close}>Change {type}</ModalHeader>
      <ModalBody>
        <p className="brand-modal__desc">{descriptions[type]}</p>
        <Form onSubmit={handleSubmit}>
          {type === RequestHistoryType.contactEmail ? (
            <FormGroup>
              <Label for="contactEmail">New email</Label>
              <Input
                type="email"
                id="contactEmail"
                placeholder="Contact email"
                value={contactEmail ?? ""}
                onChange={(e) => {
                  setContactEmail(e.target.value);
                  if (e.target.value.trim()) setShowError(false);
                }}
              />
              {showError && isNullOrEmpty(contactEmail) && (
                <p className="text-danger">Required</p>
              )}
            </FormGroup>
          ) : type === RequestHistoryType.contactMobile ? (
            <FormGroup>
              <Label for="contactMobile">New mobile</Label>
              <PhoneInput
                id="contactMobile"
                placeholder="Contact mobile"
                value={contactMobile}
                inputClass="form-control"
                inputStyle={{ width: "100%" }}
                onChange={(val) => {
                  setContactMobile(val);
                  if (val) setShowError(false);
                }}
              />
              {showError && isNullOrEmpty(contactMobile) && (
                <p className="text-danger">Required</p>
              )}
            </FormGroup>
          ) : (
            <FormGroup>
              <Label>New {type?.toLowerCase()}</Label>
              <EmailSelect
                value={approverEmail}
                onChange={(val) => {
                  setApproverEmail(val);
                  if (val) setShowError(false);
                }}
                className="react-select"
                dataLoader={dataLoader}
              />
              {showError && !approverEmail && (
                <p className="text-danger">Required</p>
              )}
            </FormGroup>
          )}

          <div className="brand-modal__actions">
            <button type="submit" className="brand-modal__btn brand-modal__btn--primary">
              <FontAwesomeIcon icon={faCheck} /> Change
            </button>
            <button type="button" className="brand-modal__btn brand-modal__btn--cancel" onClick={close}>
              <FontAwesomeIcon icon={faTimes} /> Cancel
            </button>
          </div>
        </Form>
      </ModalBody>
    </Modal>
  ) : null;
};
